/*
 * Cart minimum order 2 — checkout button lock controller
 * --------------------------------------------------------
 * The checkout button lives OUTSIDE the .js-contents that Dawn re-renders on
 * AJAX cart updates, so its server-rendered state goes stale when the cart
 * changes. This script watches the cart for changes and re-applies the locked
 * state by reading the always-present .cm2-state marker (rendered by
 * snippets/cart-minimum-banner.liquid inside the re-rendered area).
 *
 * Below the minimum  → button disabled + .cart__checkout-button--locked
 *                      (CSS shows the 🔒 lock icon + "Checkout Locked" label),
 *                      express/dynamic checkout buttons hidden.
 * At/above the minimum → button enabled + normal "Checkout" label,
 *                      express/dynamic checkout buttons shown.
 */
(function () {
  if (window.cartMin2LockInit) return;
  window.cartMin2LockInit = true;

  function isBelowMinimum() {
    // The marker is emitted on both the cart page and the drawer; any one
    // reading "true" means the current cart is below the minimum.
    return !!document.querySelector('.cm2-state[data-below-min="true"]');
  }

  function apply() {
    var below = isBelowMinimum();

    // Main checkout button(s)
    document.querySelectorAll('.cart__checkout-button').forEach(function (btn) {
      var wrapper = btn.closest('#main-cart-footer, cart-drawer');
      var isEmpty = wrapper && wrapper.classList.contains('is-empty');

      if (below) {
        btn.setAttribute('disabled', '');
        btn.classList.add('cart__checkout-button--locked');
      } else {
        btn.classList.remove('cart__checkout-button--locked');
        // Leave the empty-cart disabled state to the theme.
        if (!isEmpty) btn.removeAttribute('disabled');
      }
    });

    // Express / dynamic checkout buttons (Shop Pay, PayPal, etc.) — hide them
    // below the minimum so the gate can't be bypassed.
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (el) {
      el.classList.toggle('cart__dynamic--cm-locked', below);
    });
  }

  function start() {
    apply();

    var targets = [
      document.getElementById('main-cart-footer'),
      document.querySelector('cart-drawer'),
    ].filter(Boolean);
    if (targets.length === 0) return;

    // childList/subtree only — we never observe attributes, so toggling the
    // button's disabled/class below does not retrigger the observer.
    var observer = new MutationObserver(apply);
    targets.forEach(function (target) {
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
